export function PreactivationCreditIcon(
  props: React.ComponentPropsWithoutRef<"svg">,
) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0V0C24.8366 0 32 7.16344 32 16V16C32 24.8366 24.8366 32 16 32V32C7.16344 32 0 24.8366 0 16V16Z"
        fill="#ECFDF3"
      />
      <g clipPath="url(#clip0_5535_5279)">
        <path
          d="M13.6667 13.667H13.6738M11.232 10.0809L10.0806 11.2323C9.83562 11.4773 9.71312 11.5998 9.62551 11.7428C9.54783 11.8695 9.49059 12.0077 9.45589 12.1522C9.41675 12.3153 9.41675 12.4885 9.41675 12.835L9.41675 14.8531C9.41675 15.1996 9.41675 15.3729 9.45589 15.5359C9.49059 15.6805 9.54783 15.8186 9.62551 15.9454C9.71312 16.0884 9.83562 16.2109 10.0806 16.4559L15.5126 21.8878C16.3541 22.7294 16.7749 23.1501 17.2601 23.3078C17.6869 23.4465 18.1466 23.4465 18.5734 23.3078C19.0586 23.1501 19.4794 22.7294 20.3209 21.8878L21.8876 20.3212C22.7291 19.4796 23.1499 19.0588 23.3075 18.5737C23.4462 18.1469 23.4462 17.6871 23.3075 17.2603C23.1499 16.7751 22.7291 16.3544 21.8876 15.5128L16.4556 10.0809C16.2106 9.83587 16.0881 9.71336 15.9452 9.62575C15.8184 9.54808 15.6802 9.49084 15.5357 9.45614C15.3726 9.41699 15.1994 9.41699 14.8529 9.41699L12.8348 9.41699C12.4883 9.41699 12.315 9.41699 12.152 9.45613C12.0075 9.49084 11.8693 9.54808 11.7425 9.62575C11.5995 9.71336 11.477 9.83587 11.232 10.0809ZM14.0209 13.667C14.0209 13.8626 13.8623 14.0212 13.6667 14.0212C13.4711 14.0212 13.3126 13.8626 13.3126 13.667C13.3126 13.4714 13.4711 13.3128 13.6667 13.3128C13.8623 13.3128 14.0209 13.4714 14.0209 13.667Z"
          stroke="#067647"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5535_5279">
          <rect
            width="17"
            height="17"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
